import React from 'react';
import { PAYPAL_THEME } from '@paypalcorp/pp-react';
import { ThemeProvider } from '@emotion/react';

function withTheme(WrappedComponent, theme = 'v2') {
  const ThemedComponent = (props) => {
    return (
      <ThemeProvider theme={PAYPAL_THEME}>
        <WrappedComponent {...props} />
      </ThemeProvider>
    );
  };
  return ThemedComponent;
}

export default withTheme;
